import { render, staticRenderFns } from "./PointOfServiceDescriptionForm.vue?vue&type=template&id=709ede54&scoped=true&v-if=internal&"
import script from "./PointOfServiceDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./PointOfServiceDescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PointOfServiceDescriptionForm.vue?vue&type=style&index=0&id=709ede54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ede54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
